import React from "react";
import PropTypes from "prop-types";
import AsyncAutoComplete from "components/AsyncAutoComplete";
import loadHYContactTypesService from "services/hy/loadHYContactTypesService";

function SelectHYContactType({
  onSelect,
  disabled,
  error,
  placeholder,
  value,
  readOnly,
}) {
  return (
    <AsyncAutoComplete
      promiseFn={loadHYContactTypesService}
      onSelect={onSelect}
      textPath="name"
      labelPath="name"
      idPath="id"
      disabled={disabled}
      error={error}
      intent={!!error ? "danger" : null}
      placeholder={placeholder}
      value={value}
      readOnly={readOnly}
    />
  );
}

SelectHYContactType.propTypes = {
  onSelect: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  error: PropTypes.string,
  initialValue: PropTypes.object,
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

SelectHYContactType.defaultProps = {
  value: undefined,
  disabled: false,
  error: null,
  initialValue: {},
  placeholder: "Search...",
};

export default SelectHYContactType;
